import React from "react";
import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FileLibrary from "./FileLibrary";

export default function FileLibraryModal({ open, onClose, projectId }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: "90vh",
          borderRadius: "10px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          p: 1,
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.default",
          gap: 0.5,
        }}
      >
        <IconButton
          size="small"
          onClick={() => window.open(`/project/file_library/${projectId}`, "_blank")}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <FileLibrary params={{ id: projectId }} />
      </Box>
    </Dialog>
  );
}
